import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import {getSectionVariant} from "../../../../constants/StageSections";
import {makeStyles} from "@material-ui/styles";
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

const useStyle = makeStyles(theme => ({
    unreadElements: {
        marginLeft: theme.spacing(2)
    }
}))

function GeneralInfoSectionTitle(
    {
        section
    }) {

    const classes = useStyle();

    return (
        <GridBlock alignItems="center">
            <ExpansionPanelTitleAvatar variant={getSectionVariant(section)}/>
            <Typography variant='h6'>
                {section.name}
            </Typography>
            {(!!section.unreadDemandDocuments || !!section.unreadRfxMessages) && <div>
                    <ErrorOutlineOutlinedIcon color='error' className={classes.unreadElements} />
                </div>
            }
        </GridBlock>
    )

}

GeneralInfoSectionTitle.propTypes = {
    expanded: PropTypes.bool.isRequired,
    section: PropTypes.shape({
        section: PropTypes.string.isRequired
    }).isRequired
}

export default GeneralInfoSectionTitle;